<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button" class="navbar-toggle"
            data-toggle="collapse"
            data-target="#navigation-example-2"
            @click="toggleNavbar"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand">TRG Admin
            <ProjectName/>
          </a>
        </div>
        <!-- <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <router-link to="/register" tag="li">
              <a>Register</a>
            </router-link>
            <router-link to="/admin/overview" tag="li">
              <a>Dashboard</a>
            </router-link>
          </ul>
        </div> -->
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color="">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content" v-loading="loading">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <login-form @on-submit="onLoginSubmit"></login-form>
              </div>
            </div>
          </div>
        </div>

        <ContentFooter/>
        <!-- <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div> -->
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Register</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>

  import {mapActions, mapGetters} from 'vuex'
  import swal from 'sweetalert2'
  import AuthService from './../../services/AuthService'
  import SetupService from './../../services/SetupService'
  import LoginForm from './LoginForm'
  import ContentFooter from 'src/components/Dashboard/Layout/ContentFooter.vue'
  import ProjectName from 'src/components/ProjectName'

  export default {
    components: {
      LoginForm,
      ContentFooter,
      ProjectName
    },
    data () {
      return {
        loading: false
      }
    },
    computed: {
      ...mapGetters('project', ['project'])
    },
    mounted () {
      this.fetchOne('config')
      .then(() => {
        localStorage.setItem('eventLabel', this.project.hasOwnProperty('eventLabel') ? this.project.eventLabel : 'evento')
      })
      Promise.all([SetupService.createAdminUser(), SetupService.createConfigDoc(), SetupService.createIndexes(), SetupService.createViews(), SetupService.createDefaultRoles()])
        .then(result => {
          this.$notify({
            message: 'Setup OK',
            type: 'success',
            timeout: 2000,
            horizontalAlign: 'center',
            verticalAlign: 'bottom'
          })
          this.loading = false
        })
        .catch(err => {
          this.$notify({
            message: 'Setup Error',
            type: 'danger',
            timeout: 2000,
            horizontalAlign: 'center',
            verticalAlign: 'bottom'
          })
          this.loading = false
          console.log(err)
        })
    },
    methods: {
      ...mapActions('project', ['fetchOne']),
      ...mapActions(['setUser', 'setConfig']),
      ...mapActions('users', {getUsers: 'fetchAll'}),
      onLoginSubmit (model, isValid) {
        if (isValid) {
          AuthService.checkCredentials(model)
            .then(user => {
              if (user === false) {
                swal({
                  title: '',
                  text: 'Usuário não encontrado ou senha incorreta.',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'error'
                })
              } else {
                this.setUser(user)
                this.setConfig()
                this.getUsers({select: ['_id', 'createdAt', 'login', 'name', 'role', 'updatedAt', 'userId', 'inactivated']})
                localStorage.setItem('isLoggedIn', true)
                swal({
                  title: `Bem vindo ao ${this.project.name} / ${this.project.state}`,
                  text: 'Bom trabalho!',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                }).then(() => {
                  this.$router.push('/admin/dashboard')
                })
              }
            })
            .catch(err => {
              if (err) {
                swal({
                  title: '',
                  text: 'Ocorreu um erro e não foi possível efetuar o login.',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'error'
                })
                console.log(err)
              }
            })
        }
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue